import React from "react";
import { Box, Divider, IconButton, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ReactComponent as Logo } from "../assets/img/logo_patum_infantil.svg";
import { Login } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const Title = ({ children, button, icon }) => {
	const classes = useStyles();
	const navigate = useNavigate();

	return (
		<Box className={classes.main}>
			<Box textAlign={"center"} mt={4}>
				<Logo style={{ width: 300, height: 200, fill: "white" }} />
				<Typography variant="h3" color="white" my={3}>
					{children}
				</Typography>
				<Divider sx={{ borderColor: "white" }} />
			</Box>
			<Box className={classes.login}>
				<IconButton onClick={() => navigate("/admin/inscrits")}>
					<Login style={{ color: "white" }} />
				</IconButton>
			</Box>
		</Box>
	);
};

const useStyles = makeStyles((theme) => ({
	main: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		width: "100%",
		// borderRadius: 10,
	},
	login: {
		position: "absolute",
		top: 10,
		right: 10,
	},
}));

export default Title;
